<template>
  <div :class="[$store.state.selectedLetter === char ? 'open' : '', 'char', phrases.length === 0 ? 'empty' : '']" :id="'navSegment' + char">
    <a class="title" v-on:click="toggle()">{{char}}</a>
    <div :class="['charContent']" v-bind:style="{ maxHeight: $store.state.selectedLetter === char ? ((phrases.length * 45 + 40) + 'px') : '0px' }">
      <a :href="item.url" :id="'navPhrase' + item.phraseID" v-on:click.stop.prevent="openPhrase(item.phraseID, item.phrase, item.url, false)" :class="$store.state.selectedPhraseID === item.phraseID ? 'selected' : ''" v-for="item in phrases" :key="item.phraseID">
        <span>{{ item.phrase }}</span>

        <svg v-if="$store.state.selectedPhraseID === item.phraseID" width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M13.3536 4.35355C13.5488 4.15829 13.5488 3.84171 13.3536 3.64645L10.1716 0.464466C9.97631 0.269204 9.65973 0.269204 9.46447 0.464466C9.2692 0.659728 9.2692 0.976311 9.46447 1.17157L12.2929 4L9.46447 6.82843C9.2692 7.02369 9.2692 7.34027 9.46447 7.53553C9.65973 7.7308 9.97631 7.7308 10.1716 7.53553L13.3536 4.35355ZM0 4.5L13 4.5V3.5L0 3.5L0 4.5Z"
            fill="#061F35"/>
        </svg>
      </a>
    </div>
  </div>
</template>

<script>

    const qs = require('querystring')


    export default {
        name: 'Letter',
        props: ['char', 'phrases'],

        data: function () {
            return {
                open: false
            }
        },
        methods: {
            toggle: function () {
                let that = this;
                let updateScroll = false;

                if(this.$store.state.mobileDetailShown && this.$store.state.windowWidth < 992)
                {
                    this.$store.setSelectedLetter(this.char)
                    updateScroll = true;
                }

                else if(this.char === this.$store.state.selectedLetter)
                {
                    this.$store.state.selectedLetter = null;
                    window.setTimeout(function () {
                        that.$emit('resetScroll');
                    }, 500);
                }
                else{
                    this.$store.setSelectedLetter(this.char);
                    updateScroll = true;
                }

                if(updateScroll)
                {
                    window.setTimeout(function () {
                        let charPosition = $("#navSegment" + that.char).offset().top;
                        let scrollPosition = $("#vocNav .inner")[0].scrollTop;
                        let navHeight = $("#vocNav").height();

                        that.$store.log("running function");
                        that.$store.log(charPosition < scrollPosition);
                        that.$store.log(charPosition > (scrollPosition + navHeight));

                        if(charPosition < scrollPosition || charPosition > (scrollPosition + navHeight)){
                            var VueScrollTo = require('vue-scrollto');
                            var options = {
                                container: '#vocNav .inner',
                                easing: 'ease',
                                offset: 0,
                                x: false,
                                y: true
                            };

                            VueScrollTo.scrollTo('#navSegment' + that.char, 500, options)
                        }
                    }, 500);
                }

                this.$store.setMobileDetailShown(false)
            },
            openPhrase: function (phraseID, phrase, url, menuAutoScroll) {
                this.$emit('openPhrase', phraseID, phrase, url, menuAutoScroll)
            }
        }
    };
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Letter.vue